import React from 'react';
import ShippingFlow from "../../components/TrackingStatus/Track";
import DaysLeftCounter from "../../components/DaysProgress/index";
import CustomChip from "../../components/Chip";
import TransportTracker from "../../pages/Client/view/components/TransportTracker";

interface Status {
  label: string;
  value: string;
  status: string;
}

const liveStatus: Status[] = [
  {
    label: "Current Point",
    value: "Loading Point",
    status: "on the way",
  },
  {
    label: "Task Type",
    value: "Empty - Warehouse",
    status: "2nd Vehicle",
  },
  {
    label: "Route Status",
    value: "Good",
    status: "ETA 15.45 Hrs",
  },
  {
    label: "Container Status",
    value: "Cargo Loaded",
    status: "30.5 Tons",
  },
  {
    label: "Clearance Status",
    value: "Not yet",
    status: "2 days 12 Hr in CFH",
  },
  {
    label: "Delivery Status",
    value: "In Port",
    status: "2 days 12 Hr in Port",
  },
];

const LiveStatusSection: React.FC = () => {
  return (
    <div className="bg-white p-6 rounded-[20px] ml-2 mt-4 h-[300px] bg-[#FFFFFF]  ">
      {/* Header Section */}
      <div className="flex items-center gap-2">
        <p className="whitespace-nowrap text-[16px] leading-[30px] font-[600]">Live Status</p>

        <CustomChip
          className="whitespace-nowrap"
          text="Waiting for clearance"
          backgroundColor="#FFF5EC"
          textColor="#FFB470"
          borderColor="#FFB470"
        />
        {/* Days Left Counter */}
        <div className="ml-auto">
          <div className="flex items-center gap-2">
            <DaysLeftCounter totalDays={5} />
            <p className="text-[14px] font-[400]">Days left 30 July 2024, 06:16pm</p>
          </div>
        </div>

      </div>
      <div className='mt-10'>
        <TransportTracker />
      </div>
      <ShippingFlow />
      <div className="flex flex-wrap justify-between gap-4 mt-4 px-4">
        {liveStatus.map((status, index) => (
          <div key={index} className="">
            <p className="text-[14px] text-[#7E7E7E] font-[400]">{status.label}</p>
            <p className="text-[14px] font-[400]">{status.value}</p>
            <p className="text-[14px] font-[400] text-[#7E7E7E]">{status.status}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <div>
      <div className="mt-8 w-full">
        <LiveStatusSection />
      </div>
    </div>
  );
};

export default App;